import { render, staticRenderFns } from "./CreateMatch.vue?vue&type=template&id=d7a876aa&scoped=true&"
import script from "./CreateMatch.vue?vue&type=script&lang=js&"
export * from "./CreateMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a876aa",
  null
  
)

export default component.exports